import { defineStore } from 'pinia';

const STORAGE_KEY = 'aiEnhancerDailyUsage';
const DAILY_LIMIT = 10;

function getTodayDate() {
  const today = new Date();
  return today.toISOString().split('T')[0];
}

function loadFromStorage() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    console.error('Error loading AI enhancer usage from localStorage:', error);
    return null;
  }
}

function initializeState() {
  const stored = loadFromStorage();
  const today = getTodayDate();

  if (!stored || stored.lastUsageDate !== today) {
    return {
      usageCount: 0,
      lastUsageDate: today,
      dailyLimit: DAILY_LIMIT,
    };
  }

  return {
    usageCount: stored.usageCount || 0,
    lastUsageDate: stored.lastUsageDate,
    dailyLimit: DAILY_LIMIT,
  };
}

export const useAiEnhancerStore = defineStore('aiEnhancer', {
  state: () => initializeState(),

  getters: {
    hasReachedLimit: state => state.usageCount >= state.dailyLimit,

    remainingUses: state => {
      const remaining = state.dailyLimit - state.usageCount;
      return remaining > 0 ? remaining : 0;
    },

    canUseEnhancer: state => state.usageCount < state.dailyLimit,
  },

  actions: {
    incrementUsage() {
      this.checkAndResetDaily();

      if (this.usageCount < this.dailyLimit) {
        this.usageCount++;
        this.persistToStorage();
      }
    },

    checkAndResetDaily() {
      const today = getTodayDate();

      if (this.lastUsageDate !== today) {
        this.usageCount = 0;
        this.lastUsageDate = today;
        this.persistToStorage();
      }
    },

    persistToStorage() {
      try {
        const dataToStore = {
          usageCount: this.usageCount,
          lastUsageDate: this.lastUsageDate,
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(dataToStore));
      } catch (error) {
        console.error('Error persisting AI enhancer usage to localStorage:', error);
      }
    },
  },
});
